import React, {useState, useEffect} from 'react';
import gql from 'graphql-tag';
import {useParams} from 'react-router-dom';
//MUI
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';

//DS
import {hooks} from 'lib.front';
import {dev} from 'lib.common';
import {useCapacitacionesStyles} from './CapacitacionesStyle';
import {InfoContainer} from './componentes/InfoContainer';
import {ListaTutorial} from './componentes/ListaTutorial';
import {YouTube} from '@material-ui/icons';
import {ControlListaTutorial} from './componentes/ControlListaTutorial';
const {useApolloQ} = hooks;

const query = gql`
   query getData($codigo: String!) {
      tutorialSubArbol(codigo: $codigo) {
         codigo
         denominacion
         descripcion
         url
         observaciones
      }
   }
`;

function Capacitaciones() {
   const classes = useCapacitacionesStyles();
   const {codigo} = useParams();
   const {data} = useApolloQ(query, {}, {variables: {codigo}});
   const [maestro, setMaestro] = useState(null);
   const [capacitaciones, setCapacitaciones] = useState([]);
   const [index, setIndex] = useState(0);
   const [arrTutoriales, setArrTutoriales] = useState([]);
   const [fadeInOut, setFadeInOut] = useState(false);
   const [controlOpenLista, setControlOpenLista] = useState(false);

   useEffect(() => {
      setFadeInOut(true);
      const timer = setTimeout(() => {
         setFadeInOut(false);
      }, 600);

      return () => clearTimeout(timer); // Limpiamos el temporizador en cada cambio de índice
   }, [index]);

   useEffect(() => {
      if (data !== undefined) {
         if (
            data['tutorialSubArbol'] !== null &&
            data['tutorialSubArbol'] !== undefined &&
            data['tutorialSubArbol'].length > 0
         ) {
            asignarValores(data['tutorialSubArbol']);
            asignarArreglo(data['tutorialSubArbol']);
         }
      }
   }, [data]);

   function asignarIcono(arbol) {
      if (!Array.isArray(arbol) || arbol.length === 0) {
         return;
      }
      for (let item of arbol) {
         if (item.url !== null && item.url !== '') {
            item.icono = <YouTube />;
         } else {
            item.icono = null;
         }

         if (Array.isArray(item.hijos) && item.hijos.length > 0) {
            asignarIcono(item.hijos);
         }
      }
   }

   async function asignarArreglo(arreglo) {
      const auxArr = await arreglo.slice(1).map((itemArreglo, index) => {
         return {
            codigo: itemArreglo.codigo,
            denominacion: itemArreglo.denominacion,
            descripcion: itemArreglo.descripcion,
            url: itemArreglo.url,
            observaciones: itemArreglo.observaciones,
            posicion: index
         };
      });
      setArrTutoriales(auxArr);
   }

   async function asignarValores(arreglo) {
      const idMap = await arreglo.reduce((mapa, item, i) => {
         mapa[item.codigo] = i;
         return mapa;
      }, {});
      let raiz;

      await Promise.all(
         arreglo.map(item => {
            const idPadre = item.codigo.substring(0, item.codigo.length - 2);
            // Identificamos la raiz
            if (idPadre === null || idPadre === '') {
               raiz = item;
               return;
            }
            //Usar idMap para ubicar el elemento padre en el arreglo
            let padre = arreglo[idMap[idPadre]];
            if (!padre) {
               dev.devLog(
                  '🚀 ~ file: Capacitaciones.js:73 ~ asignarValores ~ posiblemente padre no esta activo ~ idPadre:',
                  idPadre
               );
               return;
            }
            //Agregar el elemento actual al arreglo de hijos del padre
            padre.hijos = [...(padre.hijos || []), item];
         })
      );
      if (raiz !== null && raiz !== undefined) {
         setMaestro({
            codigo: raiz.codigo,
            denominacion: raiz.denominacion,
            descripcion: raiz.descripcion,
            url: raiz.url,
            observaciones: raiz.observaciones
         });
         if (raiz.hijos.length > 0) {
            let nuevoArbol = raiz.hijos;
            asignarIcono(nuevoArbol);
            setCapacitaciones(nuevoArbol);
         }
      }
   }

   return (
      <Container>
         <Grid container spacing={3}>
            <Grid container item xs={12} justify="center">
               <Typography variant="h4" className={classes.TituloPrincipal} gutterBottom>
                  Capacitaciones en
                  {` ${maestro !== null && maestro !== undefined ? maestro.denominacion : ''}`}
               </Typography>
            </Grid>
            <Grid container item xs={12} md={4} className={classes.lista}>
               <ControlListaTutorial
                  onOpenLista={setControlOpenLista}
                  OpenLista={controlOpenLista}
               >
                  <ListaTutorial
                     capacitaciones={capacitaciones}
                     arrTutoriales={arrTutoriales}
                     onIndex={setIndex}
                     index={index}
                     onOpenLista={setControlOpenLista}
                  />
               </ControlListaTutorial>
            </Grid>
            <Grid container item xs={12} md={8} className={classes.lista}>
               <InfoContainer
                  ArrObjetos={arrTutoriales}
                  setIndex={setIndex}
                  index={index}
                  className={fadeInOut ? classes.fadeIn : classes.fadeOut}
               />
            </Grid>
         </Grid>
      </Container>
   );
}

export default Capacitaciones;
